import PropTypes from "prop-types";
import { useDarkModeData } from "src/context/DarkModeContext";
import ProgressCirc from "./ProgressCirc";

export default function LazyLoadTxt(props) {
  const { darkMode } = useDarkModeData();
  const inComponent = props.inComponent || false;
  const txt = props.txt || "Ladataan...";
  const obj = props.obj || null; //<ProgressCirc />;
  const styles = {
    div1: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 1000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // background: darkMode ? "#292929" : "#D9D9D9",
    },
    div2: {
      width: "250px",
      height: "100px",
      zIndex: 1001,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "1em",
      background: darkMode ? "#292929" : "#D9D9D9",
      color: darkMode ? "rgba(255,255,255,0.87)" : "rgba(0,0,0,0.87)",
      borderRadius: "10px",
      flexDirection: "column",
      gap: 12,
      opacity: 0.7,
    },
    inComponent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "1em",
      width: "100%",
      height: "100%",
      padding: "15px",
      opacity: 0.9,
      gap: 8,
    },
  };

  if (inComponent)
    return (
      <div style={styles.inComponent}>
        <ProgressCirc size={20} />
        {txt}
      </div>
    );
  else
    return (
      <span style={styles.div1}>
        <span style={styles.div2}>
          <span>{obj}</span>
          <span>{txt}</span>
        </span>
      </span>
    );
}

LazyLoadTxt.propTypes = {
  txt: PropTypes.string,
  inComponent: PropTypes.bool,
  obj: PropTypes.object,
};
